import { render } from "./RedeFormView.vue?vue&type=template&id=76c64736"
import script from "./RedeFormView.vue?vue&type=script&lang=js"
export * from "./RedeFormView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Workspace\\SalvandoArvores\\Codes\\salvando-arvores-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__